export const BOOKING_GET_BOOKINGS_BEGIN = 'BOOKING_GET_BOOKINGS_BEGIN';
export const BOOKING_GET_BOOKINGS_SUCCESS = 'BOOKING_GET_BOOKINGS_SUCCESS';
export const BOOKING_GET_BOOKINGS_FAILURE = 'BOOKING_GET_BOOKINGS_FAILURE';
export const BOOKING_GET_BOOKINGS_DISMISS_ERROR = 'BOOKING_GET_BOOKINGS_DISMISS_ERROR';
export const BOOKING_GET_BOOKING_BEGIN = 'BOOKING_GET_BOOKING_BEGIN';
export const BOOKING_GET_BOOKING_SUCCESS = 'BOOKING_GET_BOOKING_SUCCESS';
export const BOOKING_GET_BOOKING_FAILURE = 'BOOKING_GET_BOOKING_FAILURE';
export const BOOKING_GET_BOOKING_DISMISS_ERROR = 'BOOKING_GET_BOOKING_DISMISS_ERROR';
export const BOOKING_SET_BOOKING_BEGIN = 'BOOKING_SET_BOOKING_BEGIN';
export const BOOKING_SET_BOOKING_SUCCESS = 'BOOKING_SET_BOOKING_SUCCESS';
export const BOOKING_SET_BOOKING_FAILURE = 'BOOKING_SET_BOOKING_FAILURE';
export const BOOKING_SET_BOOKING_DISMISS_ERROR = 'BOOKING_SET_BOOKING_DISMISS_ERROR';
export const BOOKING_DELETE_BOOKING_BEGIN = 'BOOKING_DELETE_BOOKING_BEGIN';
export const BOOKING_DELETE_BOOKING_SUCCESS = 'BOOKING_DELETE_BOOKING_SUCCESS';
export const BOOKING_DELETE_BOOKING_FAILURE = 'BOOKING_DELETE_BOOKING_FAILURE';
export const BOOKING_DELETE_BOOKING_DISMISS_ERROR = 'BOOKING_DELETE_BOOKING_DISMISS_ERROR';
export const BOOKING_ADD_BOOKING_BEGIN = 'BOOKING_ADD_BOOKING_BEGIN';
export const BOOKING_ADD_BOOKING_SUCCESS = 'BOOKING_ADD_BOOKING_SUCCESS';
export const BOOKING_ADD_BOOKING_FAILURE = 'BOOKING_ADD_BOOKING_FAILURE';
export const BOOKING_ADD_BOOKING_DISMISS_ERROR = 'BOOKING_ADD_BOOKING_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/booking/redux/constants.js